import React from 'react';
import { ConceptLabel as StyledConceptLabel } from './ConceptLabel.styled';

export interface ConceptLabelProps {
  conceptName?: string;
  className?: string;
  reserveSpace?: boolean;
}

export function ConceptLabel({
  conceptName,
  className,
  reserveSpace = false,
}: ConceptLabelProps) {
  if (!conceptName) {
    if (!reserveSpace) {
      return null;
    }
    return <StyledConceptLabel className={className} aria-hidden />;
  }

  return (
    <StyledConceptLabel className={className} title={conceptName}>
      {conceptName}
    </StyledConceptLabel>
  );
}
